import type {Brand} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useBrand() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'brandGlobal',
      depth: 2,
      draft: !!route.query.preview,
    })

    return result as Populated<Brand>
  }

  return {fetch}
}
